import React from 'react';
import { ModalFooterButton } from 'components/Modal';
import PermissionNotGrantedMessage from 'components/PermissionNotGrantedMessage';
import { Step } from 'components/SteppedModal';
import useYouTubeAuthenticator, {
  UseYouTubeAuthenticatorConfig,
} from 'hooks/useYouTubeAuthenticator';

export interface UseAccessDeniedStepConfig
  extends Pick<UseYouTubeAuthenticatorConfig, 'onError'>,
    Pick<Step, 'title'> {
  onReviseAccess?: () => void;
}

export default function useAccessDeniedStep({
  onError,
  onReviseAccess,
  title = 'we need permission to post',
}: UseAccessDeniedStepConfig): Step {
  const { authenticating, withAuthentication } = useYouTubeAuthenticator({
    onError,
    force: true,
  });

  return {
    title,
    component: <PermissionNotGrantedMessage />,
    id: 'access-denied',
    renderFooterButtons: ({ cancel, submit }) => [
      <ModalFooterButton {...cancel} key="cancel">
        cancel
      </ModalFooterButton>,
      <ModalFooterButton
        {...submit}
        disabled={authenticating}
        key="submit"
        onClick={withAuthentication(onReviseAccess)}
        theme="submit"
      >
        revise options
      </ModalFooterButton>,
    ],
  };
}
